import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { StageN } from 'src/app/accounts-v2/models/stage.model';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { CrmSettingModel } from 'src/app/configurations/models/organization-settings.model';
import { AppRuleSelectionService } from 'src/app/modules/shared/components/rule-selection/app.rule.selection.service';
import { AccountModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { CrmSettingsService } from 'src/app/modules/shared/services/crm-settings.service';
import { UserService } from 'src/app/service/userservice';

@Component({
  selector: 'app-account-move-dialog',
  templateUrl: './account-move-dialog.component.html',
  styleUrls: ['./account-move-dialog.component.scss']
})
export class AccountMoveDialogComponent implements OnInit, OnDestroy{

  @Input() displayAccountMoveDialog: boolean = false;
  // get data of selected account from parent 
  @Input() selectedAccountForMove: any;
  @Input() allAccountChannelListForMove: any;
  @Input() currentSelectedChannelId: any;
  @Output() cancelMoveAccountModal = new EventEmitter<any>();
  @Output() saveMoveAccountModal = new EventEmitter<any>();

  private ngUnsubscribe = new Subject<void>();

  allChannelName: any;
  filteredOptions: any;
  selectedAccountChannelForMove: any;
  selecteStageForMove: any;

  stagesCountN: StageN[] = [];
  pageNumber: number = 1;
  pageSize: number = 15;
  first: number = 0;
  isActive: boolean = true;
  activeUsers: any[] = [];
  stageOwnerId: number;
  accountOwnerSettings: any = {};
  constructor(
    public appMainService: AppMainService,
    private accountServiceN: AccountServiceN,
    private messageService: MessageService,
    public app: AppMainComponent,
    public userService: UserService,
    private ruleService: AppRuleSelectionService,
    private crmSettingsService: CrmSettingsService,
  ) { }

  ngOnInit(): void 
  {
    this.allChannelName = this.allAccountChannelListForMove.filter(option => option.id !== this.currentSelectedChannelId);
    this.getUserList();
    // this.getSettingsData();
  }

  cancelAccountMove() {
    this.cancelMoveAccountModal.emit();
  }

  saveAccountMove() {
    this.moveSelectedAccountToDifferentChannel();
  }

  onChannelChange() {
    this.selecteStageForMove = null;
    this.getStages();
  }


  getStages() {
    this.appMainService.isShowSpinner('getStages');
    this.ruleService
      .getStageList(AccountModuleId, this.selectedAccountChannelForMove?.id, false)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          if (response) {
            this.stagesCountN = response;
            this.getUserList();
            this.appMainService.isHideSpinner('getStages');
          }
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getStages');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.message ? error?.error?.Message : 'Stages are not loaded, please try again...'
          });
        }
      });
  }

  moveSelectedAccountToDifferentChannel() {
    const selectedAccountData = {
      accountId: this.selectedAccountForMove.id,
      channelId: this.selectedAccountChannelForMove?.id,
      stageId: this.selecteStageForMove.id,
    }
    this.accountServiceN.moveAccount(selectedAccountData).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: () => {
              this.messageService.add
              ({
                  severity: 'success',
                  summary: 'Success',
                  detail: `Account ${this.selectedAccountForMove.businessName} moved succesfully`
              });
          this.saveMoveAccountModal.emit(this.selectedAccountChannelForMove);
      },
      error: (error) => {
                    this.messageService.add
                    ({
                        severity: 'error',
                        summary: 'Error',
                        detail: `Account' + ${this.selectedAccountForMove.businessName} is not moved, please try again...`
                    });
                    this.saveMoveAccountModal.emit();
      },
    });
  }

  getUserList() {
    this.userService.getUsers(this.app.companyId).then(users => {
      if (users && users.length) {
        this.activeUsers = users.sort((a, b) => a.name.localeCompare(b.name));
      }
    });
  }

  setStageOwnerAccordingToStage(value) {
    if (value) {
      if(this.accountOwnerSettings?.enabled){
        this.stageOwnerId = value?.ownerId || this.app.user?.userId;
      }else{
        this.stageOwnerId = value?.ownerId || null;
      }
    }
  }

    // ------------stage owner work
    getSettingsData() {
      this.crmSettingsService.getCrmSettingFieldsList().subscribe({
        next: (response: CrmSettingModel[]) => {
          this.accountOwnerSettings = response?.find(data => data?.moduleId == AccountModuleId && data?.code == "StageOwnerSetting");
        },
        error: (error) => { }
      });
    }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
